// extracted by mini-css-extract-plugin
export default {"matchBox":"match-center_matchBox__WPggO","rowwBox":"match-center_rowwBox__7M8Hi","tabBox":"match-center_tabBox__vuR+0"};